import { zonedNow } from '@reditelji/shared';
import { useEffect, useState } from 'react';

export interface WallClock {
  /** YYYY-MM-DD in Europe/Ljubljana. */
  isoDate: string;
  /** Minutes from midnight in Europe/Ljubljana. */
  minutes: number;
}

/**
 * The wall clock for live mode, Europe/Ljubljana. In dev builds it can be
 * pinned for testing via localStorage: `rr_sim_date` = "2026-09-19",
 * `rr_sim_time` = "14:20" (either alone works too).
 */
export function readClock(): WallClock {
  const real = zonedNow();
  if (import.meta.env.DEV) {
    const simDate = localStorage.getItem('rr_sim_date');
    const simTime = localStorage.getItem('rr_sim_time');
    const m = simTime ? /^(\d{1,2}):(\d{2})$/.exec(simTime.trim()) : null;
    return {
      isoDate: simDate?.trim() || real.isoDate,
      minutes: m ? Number(m[1]) * 60 + Number(m[2]) : real.minutes,
    };
  }
  return real;
}

/** Ticking wall clock (30 s resolution — the UI works in whole minutes). */
export function useNow(): WallClock {
  const [clock, setClock] = useState<WallClock>(readClock);
  useEffect(() => {
    const t = setInterval(() => {
      setClock((prev) => {
        const next = readClock();
        return next.minutes === prev.minutes && next.isoDate === prev.isoDate ? prev : next;
      });
    }, 30_000);
    return () => clearInterval(t);
  }, []);
  return clock;
}
